import { Vector3 } from "three";
import { Cartographic } from "../Cartographic";
import { Rectangle } from "../Rectangle";
/**
 * An identity projection.
 *
 * That is: the output of this projection will simply be a copy of the input.
 *
 * @see MapProjection
 */
export class IdentityProjection {
    constructor(ellipsoid) {
        this._ellipsoid = ellipsoid;
    }
    /**
     * @see MapProjection.ellipsoid
     */
    get ellipsoid() {
        return this._ellipsoid;
    }
    get region() {
        return Rectangle.MAX;
    }
    /**
     * @see MapProjection.project
     */
    project(cartographic, result = new Vector3()) {
        const x = cartographic.longitude;
        const y = cartographic.latitude;
        const z = cartographic.height;
        return result.set(x, y, z);
    }
    /**
     * @see MapProjection.unproject
     */
    unproject(cartesian, result = new Cartographic()) {
        const longitude = cartesian.x;
        const latitude = cartesian.y;
        const height = cartesian.z;
        return result.set(longitude, latitude, height);
    }
}
